import ClockIcon from "../../assets/icons/Clock";
import EmailIcon from "../../assets/icons/Email";
import LocationIcon from "../../assets/icons/LocationIcon";
import PhoneIcon from "../../assets/icons/Phone";
import { postForm } from "../../services/contactService";
import "./Contact.scss";
import FormItem from "./components/FormItem";
import { useState } from "react";
import { toast } from "react-toastify";

const Contact = () => {
  const [contactForm, setContactForm] = useState({
    firstName: "",
    lastName: "",
    subject: "",
    phone: "",
    email: "",
    orderReference: "",
    message: "",
  });

  const handleContactUs = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    postForm(contactForm).then((res) => {
      if (res?.status === 201) {
        toast.success("Message envoyé !", {
          className: "toast-success",
        });
      }
      setContactForm({
        firstName: "",
        lastName: "",
        subject: "",
        phone: "",
        email: "",
        orderReference: "",
        message: "",
      });
    });
  };

  return (
    <div id="contact">
      <div>
        <h2>CONTACTEZ-NOUS</h2>
        <div className="container">
          <div className="form-container">
            <form onSubmit={handleContactUs}>
              <div className="flex-div">
                <FormItem
                  type="input"
                  placeholder="Nom*"
                  keyFrom="lastName"
                  required
                  form={contactForm}
                  onChange={(value) =>
                    setContactForm({
                      ...contactForm,
                      lastName: value,
                    })
                  }
                />
                <FormItem
                  type="input"
                  placeholder="Prénom*"
                  keyFrom="firstName"
                  required
                  form={contactForm}
                  onChange={(value) =>
                    setContactForm({
                      ...contactForm,
                      firstName: value,
                    })
                  }
                />
              </div>
              <FormItem
                type="input"
                placeholder="Objet*"
                keyFrom="subject"
                required
                form={contactForm}
                onChange={(value) =>
                  setContactForm({
                    ...contactForm,
                    subject: value,
                  })
                }
              />
              <FormItem
                type="email"
                placeholder="Adresse e-mail*"
                keyFrom="email"
                required
                form={contactForm}
                onChange={(value) =>
                  setContactForm({
                    ...contactForm,
                    email: value,
                  })
                }
              />
              <FormItem
                type="input"
                placeholder="N° de téléphone*"
                keyFrom="phone"
                required
                form={contactForm}
                onChange={(value) =>
                  setContactForm({
                    ...contactForm,
                    phone: value,
                  })
                }
              />
              <FormItem
                type="input"
                placeholder="Référence de commande"
                keyFrom="orderReference"
                form={contactForm}
                onChange={(value) =>
                  setContactForm({
                    ...contactForm,
                    orderReference: value,
                  })
                }
              />
              <FormItem
                type="textarea"
                placeholder="Message*"
                keyFrom="message"
                required
                form={contactForm}
                onChange={(value) =>
                  setContactForm({
                    ...contactForm,
                    message: value,
                  })
                }
              />
              <div className="validate">
                <button type="submit">Envoyer</button>
              </div>
            </form>
          </div>
          <div className="info-pratique">
            <div>
              <h3>INFOS PRATIQUES</h3>
              <div>
                <div>
                  <LocationIcon width="30px" height="30px" />
                  <div className="square"></div>
                </div>
                <div>
                  Z.I. la Prairie
                  <br />
                  Rue de la Prairie
                  <br />
                  91140 Villebon-sur-Yvette
                </div>
              </div>
              <div>
                <div>
                  <PhoneIcon width="24px" height="24px" />
                  <div className="square"></div>
                </div>
                <div>01 69 34 92 28</div>
              </div>
              <div>
                <div>
                  <EmailIcon width="24px" height="24px" />
                  <div className="square"></div>
                </div>
                <div>info@sphygiene.com</div>
              </div>
              <div>
                <div>
                  <ClockIcon width="24px" height="24px" />
                  <div className="square"></div>
                </div>
                <div>
                  Horaires d’ouverture <br />
                  Du lundi au jeudi <br />
                  8h00 - 17h00
                  <br />
                  Vendredi <br />
                  8h00 - 16h00
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="location-img">
        <img src="/images/contact/location.png" alt="location" />
      </div>
    </div>
  );
};

export default Contact;
